<template>
  <div class="main">
    <div class="box" v-show="!loading">
      <van-tabs
        type="card"
        class="top-tabs"
        color="#236DFF"
        v-model="currentTab"
        @click="clickTabs"
      >
        <van-tab title="图片" name="1">
          <div class="swiper-container" v-show="poster.length&&showPoster&&!isOne">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,i) in poster" :key="i">
                <div class="img-box">
                  <!-- <div class="top-title">{{item.name}}</div> -->
                  <van-image :src="item.url" class="img" />
                </div>
              </div>
            </div>
            <div
              class="iconfont arr-left"
              v-show="poster.length>1&&0!=index&&currentTab!=2"
            >&#xe622;</div>
            <div
              class="iconfont arr-right"
              v-show="poster.length>1&&poster.length-1!=index&&currentTab!=2"
            >&#xe674;</div>
          </div>
          <div class="img-box" v-show="isOne">
            <div class="top-title">{{poster[index]&&poster[index].name}}</div>
            <van-image :src="poster[index]&&poster[index].url" class="img" />
          </div>
          <div class="img-info" v-if="!$config.isApp">长按海报即可保存到手机</div>
          <div class="share-box" v-if="$config.isApp" >
            <div class="share-item" @click="operate(1)">
              <img class="icon" src="@static/images/material/down.png" />
              <div class="text">保存到手机</div>
            </div>
            <div class="share-item" @click="operate('pyq')">
              <img class="icon" src="@static/images/material/py.png" />
              <div class="text">朋友圈</div>
            </div>
            <div class="share-item" @click="operate('wx')">
              <img class="icon" src="@static/images/material/wx.png" />
              <div class="text">微信好友</div>
            </div>
          </div>
        </van-tab>
        <van-tab title="文案" name="2">
          <div class="img-box">
            <div class="top-title">{{poster[index]&&poster[index].name}}</div>
            <div class="paperwork">
              <p>{{ copywriting}}</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="img-footer">
        <div class="card" v-show="!isNull(copywriting)&&currentTab==2" @click="copyText()">
          <img class="icon" src="@static/images/material/text.png" />
          <div class="desc">复制文案</div>
        </div>
        <!-- <div class="card" v-if="currentTab==1" @click="operate(1)">
          <img class="icon" src="@static/images/material/xz.png">
          <div class="desc">下载图片</div>
        </div>
        <div class="card" v-if="currentTab==1" @click="operate('wx')">
          <img class="icon" src="@static/images/material/wx.png">
          <div class="desc">微信好友</div>
        </div>
        <div class="card" v-if="currentTab==1"  @click="operate('pyq')">
          <img class="icon" src="@static/images/material/pyq.png">
          <div class="desc">转发朋友圈</div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "static/js/swiper-4.3.3.min";
import "static/css/swiper-4.3.3.min.css";
import { loading, share } from "@/api/mixins";
export default {
  mixins: [loading, share],
  data() {
    return {
      copywriting: "",
      currentTab: "1",
      title: "",
      showPoster: false,
      isOne: false,
      loading: false,
      mySwiper: {},
      id: "", //产品id
      imgOri: "", //原图
      poster: [{ name: "", copywriting: "" }],
      index: 0,
      code: "",
      img: "", //加上二维码的图
      mechanId: "",
      shareData: {
        link: "", //分享的链接地址
        title: "", //分享的标题
        logo: "", //分享的图片
        content: "" //分享的描述
      }
    };
  },
  created() {
    this.code = this.$route.query.code;
    this.id = this.$route.query.id;
    this.loading = true;
    const query = this.$route.query;
    this.index = query.index;
    this.getData();
    try {
      const user = JSON.parse(localStorage.jzy_user);
      this.userId = user.userId;
    } catch (error) {
      console.log("获取用户信息异常");
    }
  },
  methods: {
    // tab切换
    clickTabs(val) {
      this.currentTab = val;
    },
    // 获取海报列表
    getData() {
      const params = {
        pageNum: 1,
        pageSize: 20,
        typeId: this.$route.query.typeId,
        keyWord: this.$route.query.keyWord,
        code: this.$route.query.code
      };
      if (["allPoster", "posterHotProduct"].includes(this.code)) {
        params.productId = this.id;
      }
      this.$http({
        url: "/app/information/queryPosterList",
        type: "PUT",
        data: params
      }).then(resData => {
        this.loading = false;
        if (resData.total > 0) {
          try {
            this.poster = resData.data;
            // 海报
            this.imgOri = this.poster[this.index].url;
            // 标题
            this.title = this.poster[this.index].name;
            this.productCode = this.poster[this.index].productCode;
            // 文案
            this.copywriting = this.poster[this.index].copywriting;
          } catch (error) {
            console.log("解析海报异常");
          }
          if (["allPoster", "posterHotProduct"].includes(this.code)) {
            this.isOne = false;
            setTimeout(() => {
              // Swiper.use([Navigation])
              this.mySwiper = new Swiper(".swiper-container", {
                navigation: {
                  nextEl: ".arr-right",
                  prevEl: ".arr-left"
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                on: {
                  transitionEnd: () => {
                    if (typeof this.mySwiper.activeIndex == "undefined") {
                      return;
                    }
                    this.index = this.mySwiper.activeIndex; //切换结束时，告诉我现在是第几个slide
                    this.copywriting = this.poster[this.index].copywriting;
                    this.imgOri = this.poster[this.index].url;
                    if (!this.$config.isApp) {
                      this.toInitShare()
                    }
                  }
                }
              });
              this.mySwiper.slideTo(this.index, 1, true);
              // 数据加载完成再显示页面
              this.showPoster = true;
            }, 100);
          } else {
            // 海报
            this.isOne = true;
            const poster = this.poster[this.index];
            this.imgOri = poster.url;
            // 标题
            this.title = poster.name;
            this.copywriting = poster.copywriting;
            this.showPoster = true;
             this.toInitShare()
            // this.operate(1);
          }
         if (!this.$config.isApp) {
             this.toInitShare()
         }
        }
      });
    },
    toInitShare(){
      if (!this.$config.isApp) {
        const imgUrl = this.imgOri
          .replace("https://agency-b.wts9999.net", "")
          .replace("https://admin.jiangziya99.com", "");
          console.log(imgUrl);
          let img;
          if(this.productCode){
            img = this.$config.ajaxRoot +
            "/app/product/createPosterImgV2?posterUrl=" +
            encodeURIComponent(imgUrl) +
            "&productCode=" +
            this.productCode +
            "&userId=" +
            this.userId;
          }else{
            img = imgUrl;
          }
            const shareData = {
              link: img,
              title: this.title, //分享的标题
              logo: this.imgOri, //分享的图片
              content: "点击查看" + this.title + "产品海报" //分享的描述
            };
            console.log(shareData);
            this.shareInit(shareData);
      }
    },
    isNull(str) {
      return !str && str !== 0 && typeof str !== "boolean" ? true : false;
    },
    // 复制文案
    copyText() {
      this.copywriting = this.poster[this.index].copywriting;
      if (this.copywriting) {
        const cInput = document.createElement("input");
        cInput.value = this.copywriting;
        document.body.appendChild(cInput);
        // 选取文本域内容;
        cInput.select();
        // 执行浏览器复制命令
        // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
        // Input要在正常的编辑状态下原生复制方法才会生效
        document.execCommand("Copy");
        this.$notice.msg("复制成功");
        /// 复制成功后再将构造的标签 移除
        cInput.remove();
      }
    },
    operate(target) {
      let img = new Image();
      img.src = this.imgOri;
      // 判断是否有缓存
      if (img.complete) {
        // 打印数据
        console.log(
          "from : complete - width:" + img.width + ", height:" + img.height
        );
        this.operateCallback(target, img.width, img.height);
      } else {
        // 加载完执行
        img.onload = () => {
          // 打印数据
          console.log(
            "from : onload - width:" + img.width + ", height:" + img.height
          );
          this.operateCallback(target, img.width, img.height);
        };
      }
    },
    // target 1保存 wx微信分享 pyq朋友圈
    operateCallback(target, width, height) {
      const imgUrl = this.imgOri
        .replace("https://agency-b.wts9999.net", "")
        .replace("https://admin.jiangziya99.com", "");
      console.log(imgUrl);
      let img;
      if(this.productCode){
        img = this.$config.ajaxRoot +
        "/app/product/createPosterImgV2?posterUrl=" +
        encodeURIComponent(imgUrl) +
        "&productCode=" +
        this.productCode +
        "&userId=" +
        this.userId;
      }else{
        img = imgUrl;
      }
      if (target == 1) {
        this.saveImg(img, width, height);
      } else {
        this.openShare(target, img);
      }
    },
    // 打开分享
    openShare(target, img) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 2000);
      this.$app.openShare({
        type: 2,
        link: img,
        target: target,
        apiPermissionCode:'APP_PROMOTEBUSINESS_POSTER'
      });
    },
    //保存相册
    saveImg(img, width, height) {
      console.log('图片地址',img)
      let this_ = this;
       this.$app.download(
          {
            type: "image",
            url: img
          },
          res => {
            this_.$notice.msg("保存成功");
            this_.$tools.getHealthTest('APP_PROMOTEBUSINESS_POSTER');
          },
          res => {
            this.$notice.msg("保存失败");
          }
        );
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./poster.scss";
</style>
